'use strict';

angular.module('mean.general-tasks').controller('SubTasksController', ['$scope', 'Global', 'Menus', '$rootScope', '$http', 'Subtasks', '$filter', 'Materials', 'Equipments', 'Units', 'tradeCodeService',
    function ($scope, Global, Menus, $rootScope, $http, Subtasks, $filter, Materials, Equipments, Units, tradeCodeService) {

        $scope.global = Global;
        $scope.subtasks = [];
        $scope.projectType = {};
        $scope.subtasks.materials = [];
        $scope.subtasks.equipments = [];
        var data;

        $scope.trade_array = tradeCodeService.getArray();

        $scope.hasAuthorization = function (subtask) {
            if (!subtask || !subtask.user) return false;
            return $scope.global.isAdmin || subtask.user._id === $scope.global.user._id;
        };

        $scope.initSub = function () {
            $scope.units = Units.query();
        };

        $scope.getGeneralTasks = function () {
            if ($scope.projectType) {
                Subtasks.query({ 
                    projectType: $scope.projectType.type, 
                    geoLocation: $scope.projectType.location }, function (subtasks) {
                    $scope.subtasks = subtasks;
                });
            }
        }

        $scope.getUserSubtasks = function () {
            $scope.user_subtasks = [];

            Subtasks.query({ 
                subtask_trade: $scope.projectType.type, 
                isCustom: true }, function (subtasks) {
                $scope.user_subtasks = subtasks;
            });
        }

        $scope.onSelect = function () {
            if ($scope.selectedItem) {
                data = $filter('filter')($scope.subtasks, { subtask_trade: $scope.selectedItem.value });
            } else {
                data = $scope.subtasks;
            }
        };

        $scope.add = function () {
            if (!$scope.subtasks) $scope.subtasks = [];
            var na_unit = $filter('filter')($scope.units, { 'unit': 'NA' }, true);
            $scope.subtask_code = $scope.subtask_trade.value + $scope.subtask;

            if (!$scope.subtask_project_type) {
                alert('Select Project Type');
                return;
            }

            var subtask = new Subtasks({
                subtask_code: $scope.subtask_trade.value + $scope.subtask,
                subtask_trade: $scope.subtask_trade.value,
                subtask: $scope.subtask,
                subtask_name: $scope.subtask_name,
                unit: na_unit[0]._id,
                projectType: $scope.subtask_project_type.type,
                geoLocation: $scope.subtask_project_type.location,
                piece_rate: 0,
                crew_rate: 0,
                piece_per_hour_rate: 0,
                isCustom: false,
                userId: ''
            });

            subtask.$save(function (response) {
                $scope.subtasks.push(response);

                data = $scope.subtasks;
            });

            this.subtask_code =
                this.subtask_trade =
                this.subtask =
                this.subtask_name =
                this.unit =
                this.piece_rate =
                this.crew_rate =
                this.piece_per_hour_rate = '';
            this.subtask_project_type = '';
        };

        $scope.remove = function (subtask) {
            for (var i in $scope.subtasks) {
                if ($scope.subtasks[i] === subtask) {
                    $scope.subtasks.splice(i, 1);
                }
            }

            subtask.$remove();
            data = $scope.subtasks;
        };

        $scope.update = function (subtask, subtaskField) {
            subtask.subtask_code = subtask.subtask_trade + subtask.subtask;
            subtask.$update();
            $scope.editSubId = -1;
        };

        $scope.setEditSubId = function (pid) {
            $scope.editSubId = pid;
        };

        $scope.getTradeName = function (id) {
            return tradeCodeService.getName(id);
        };

        $scope.subtaskFileSelected = function () {
            var lines, data;
            var _self = this;
            lines = this.$parent.fileContent.split('\n');
            var holder = [];
            var is_clean = true;
            Subtasks.query({}, function (subtasks) {
                for (var i = lines.length - 1; i > 0; i--) {
                    var l = lines[i];

                    data = l.split(',');

                    if (!data[0]) continue;

                    var inlist = $filter('filter')(holder, { 'subtask_code': data[1] }, true);
                    if (inlist.length > 0) {
                        alert('Sub Task code ' + data[3] + ' already exists. Remove all, fix, and retry.');
                        is_clean = false;
                        break;
                    }

                    inlist = $filter('filter')(holder, { 'subtask_name': data[2] }, true);
                    if (inlist.length > 0) {
                        alert('Sub Task name ' + data[4] + ' already exists. Remove all, fix, and retry.');
                        is_clean = false;
                        break;
                    }

                    var subtask_code = data[0];
                    var subtask_name = data[1];
                    var subtask_trade = data[2];
                    var subtask = data[3];
                    var projectType = data[4];
                    var geoLocation = data[5];
                    var piece_rate = data[6] ? Number(data[6].replace('$', '')) : 0;
                    var pphrate = data[7] ? Number(data[7].replace('$', '')) : 0;
                    var crew_rate = data[8] ? Number(data[8].replace('$', '')) : 0;
                    var unit = data[9] ? data[9] : 'NA';
                    var found = $scope.units.filter(item => item["unit"] === unit.trim());
                    if (found && found.length) {
                        unit = found[0]._id;
                    } else {
                        continue;
                    }

                    if (_self.projectType && _self.projectType.type && _self.projectType.location) {
                        projectType = _self.projectType.type;
                        geoLocation = _self.projectType.location;
                    } else {
                        continue;
                    }

                    var isDuplicate = $filter('filter')(holder, {
                        'subtask_name': subtask_name,
                        'subtask_code': subtask_code,
                        'projectType': projectType,
                        'geoLocation': geoLocation
                    }, true);

                    if (isDuplicate.length === 0) {
                        var task = new Subtasks({
                            "subtask_code": subtask_code,
                            "subtask_name": subtask_name,
                            "subtask_trade": subtask_trade,
                            "subtask": subtask,
                            "projectType": projectType,
                            "geoLocation": geoLocation,
                            "piece_rate": piece_rate,
                            "piece_per_hour_rate": pphrate,
                            "crew_rate": crew_rate,
                            "unit": unit,
                            'isCustom': false,
                            'userId': ''
                        });

                        holder.push(task);
                    }
                }
                if (is_clean && holder.length) {
                    var subtasks2 = _self.$parent.subtasks;
                    Subtasks.bulkAdd(holder, function (results) {
                        results.forEach(function (item) {
                            subtasks2.push(item);
                        });
                    });
                }
                delete _self.$parent.fileContent;
            });
        };

        $scope.ConvertSubtaskToCSV = function (objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = 'subtask_code,subtask_name,subtask_trade,subtask,project_type,geographical_location,piece_rate,piece_per_hour_rate,crew_rate,unit\r\n';

            for (var i = 0; i < array.length; i++) {
                var unitName = 'NA';
                var findItem = $scope.units.filter(item => item.unit === array[i].unit);
                (array[i].unit && findItem.length) && (unitName = findItem[0].unit);
                str += array[i].subtask_code + ',' + array[i].subtask_name + ','
                    + array[i].subtask_trade + ',' + array[i].subtask + ','
                    + array[i].projectType + ',' + array[i].geoLocation + ',' + '$' + array[i].piece_rate + ','
                    + '$' + array[i].piece_per_hour_rate + ',' + '$' + array[i].crew_rate + ','
                    + unitName;
                str += '\r\n';
            }

            return str;
        };

        $scope.exportSubtaskFile = function () {
            $scope.subtasks = $filter('orderBy')($scope.subtasks, 'subtask');
            var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertSubtaskToCSV($scope.subtasks));
            var link = document.createElement('a');
            angular.element(link)
                .attr('href', dataUrl)
                .attr('download', 'subtasks.csv') // Pretty much only works in chrome
            link.click();
        };

        $scope.deleteSubtaskAll = function () {
            $scope.subtasks.forEach(function (subtask) {
                subtask.$delete();
            });
            $scope.subtasks = [];
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/controllers/subtasks.js